import { useEffect } from "react";
import { LobbyProvider, useLobby } from "~/app";
import { Colors, Spacing } from "~/jsx/theme";
import {
  LobbyGame,
  LobbyUser,
  NewLobbyGame,
  SyncIcon,
  groupBy,
  lobbyCommandBuilder,
  useSession,
  useSessionUser,
} from "~/utils";
import { XTypography } from "../design";
import { XLobbyGamesList } from "./XLobbyGamesList";
import { XLobbyNewGameForm } from "./XLobbyNewGameForm";
import { XLobbyUser } from "./XLobbyUser";

export const XListGamesPage = () => {
  return (
    <LobbyProvider>
      <Layout>
        <PageContent />
      </Layout>
    </LobbyProvider>
  );
};

export default XListGamesPage;

const Layout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div
      style={{
        background: "url('/image/lobby-background.png')",
        backgroundRepeat: "round",
        height: "100%",
        color: Colors.common.white,
      }}
    >
      <div
        style={{
          margin: "auto",
          maxWidth: 1104,
          background: "rgba(0, 0, 0, 0.3)",
          height: "100%",
          padding: Spacing.px32,
        }}
      >
        {children}
      </div>
    </div>
  );
};

const PageContent = () => {
  const { setValue: setSession } = useSession();

  const sessionUser = useSessionUser();
  const sessionId = sessionUser.id;
  const { state, update, syncStatus } = useLobby();
  const { games } = state;
  console.info(state);

  useEffect(() => {
    const listener = () => {
      const commands = games.flatMap((game) => {
        if (LobbyGame.isInGame(game, sessionId)) {
          return [lobbyCommandBuilder("leave")(game.id)];
        } else {
          return [];
        }
      });
      commands.forEach((command) => update(command));
    };
    window.addEventListener("beforeunload", listener);
    window.addEventListener("unload", listener);
  }, []);

  const onNewGame = (lobbyGame: NewLobbyGame) => {
    const command = lobbyCommandBuilder("create")({
      ...lobbyGame,
      id: Math.random().toString().substring(2),
    });
    update(command);
  };

  const onUpdateName = (newName: string) => {
    const newSessionUser: LobbyUser = {
      ...sessionUser,
      name: newName,
    };
    setSession({
      user: newSessionUser,
    });
    const command = lobbyCommandBuilder("updateUserProps")({
      userId: sessionUser.id,
      props: {
        name: newName,
      },
    });
    update(command);
  };

  const groupedGames = groupBy(games, (game) => {
    if (game.endedBy) return "ended";
    if (LobbyGame.isInGame(game, sessionId)) return "mine";
    if (game.started) return "started";
    return "open";
  });
  const myGames = groupedGames.mine ?? [];
  const openGames = groupedGames.open ?? [];

  return (
    <div>
      <div style={{ position: "absolute", top: 0, right: 0 }}>
        <SyncIcon syncStatus={syncStatus} />
      </div>
      <XTypography>my session: {sessionId}</XTypography>
      <div style={{ margin: Spacing.px18 }}>
        <XLobbyUser user={sessionUser} onUpdate={onUpdateName} />
      </div>
      <XLobbyGamesList title="Your games" games={myGames} />
      <XLobbyGamesList
        title="Open games"
        games={openGames}
        style={{ marginTop: Spacing.px32 }}
      />
      <div style={{ marginTop: Spacing.px24 }}>
        <XLobbyNewGameForm onCreate={onNewGame} visible={true} />
      </div>
    </div>
  );
};
